import React from 'react';
import { useMusicPlayer } from '../context/MusicPlayerContext';

const MusicPlayerDemo = () => {
  const { playSong } = useMusicPlayer();

  // Sample songs for demonstration
  const sampleSongs = [
    {
      id: 1,
      title: "Sample Song 1",
      artist: "Demo Artist",
      album: "Demo Album",
      audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav" // Sample audio URL
    },
    {
      id: 2,
      title: "Sample Song 2",
      artist: "Demo Artist 2",
      album: "Demo Album 2",
      audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav"
    },
    {
      id: 3,
      title: "Sample Song 3",
      artist: "Demo Artist 3",
      album: "Demo Album 3",
      audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav"
    }
  ];

  const handlePlaySong = (song) => {
    playSong(song, sampleSongs);
  };

  const handlePlayAll = () => {
    playSong(sampleSongs[0], sampleSongs);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-slate-800/50 rounded-xl p-6 border border-white/10">
        <h1 className="text-3xl font-bold text-white mb-6">Music Player Demo</h1>
        
        <div className="space-y-4">
          <div className="bg-slate-700/50 rounded-lg p-4">
            <h2 className="text-xl font-semibold text-white mb-3">Instructions</h2>
            <p className="text-slate-300 mb-4">
              This demo shows how the persistent music player works. Click any song below to start playing. 
              The music will continue playing even when you switch to different tabs/pages.
            </p>
            <button
              onClick={handlePlayAll}
              className="px-6 py-3 bg-gradient-to-r from-fuchsia-500 to-purple-600 text-white rounded-lg font-semibold hover:from-fuchsia-600 hover:to-purple-700 transition-all duration-200"
            >
              Play First Song
            </button>
          </div>

          <div className="bg-slate-700/50 rounded-lg p-4">
            <h2 className="text-xl font-semibold text-white mb-3">Sample Songs</h2>
            <div className="space-y-2">
              {sampleSongs.map((song) => (
                <div
                  key={song.id}
                  className="flex items-center justify-between p-3 bg-slate-600/50 rounded-lg hover:bg-slate-600/70 transition-all duration-200"
                >
                  <div className="flex-1">
                    <h3 className="text-white font-medium">{song.title}</h3>
                    <p className="text-slate-300 text-sm">{song.artist}</p>
                  </div>
                  <button
                    onClick={() => handlePlaySong(song)}
                    className="px-4 py-2 bg-fuchsia-500 text-white rounded-lg hover:bg-fuchsia-600 transition-all duration-200"
                  >
                    Play
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-slate-700/50 rounded-lg p-4">
            <h2 className="text-xl font-semibold text-white mb-3">Features</h2>
            <ul className="text-slate-300 space-y-2">
              <li>✅ Music continues playing when switching tabs</li>
              <li>✅ Play/pause controls</li>
              <li>✅ Next/previous song navigation</li>
              <li>✅ Volume control</li>
              <li>✅ Progress bar with seek functionality</li>
              <li>✅ Shuffle and repeat modes</li>
              <li>✅ Expandable player view</li>
              <li>✅ Only stops when explicitly closed</li>
            </ul>
          </div>

          <div className="bg-slate-700/50 rounded-lg p-4">
            <h2 className="text-xl font-semibold text-white mb-3">Test Instructions</h2>
            <ol className="text-slate-300 space-y-2 list-decimal list-inside">
              <li>Click "Play First Song" or any song above</li>
              <li>Notice the music player appears at the bottom</li>
              <li>Switch to different tabs (Dashboard, Search, Library, etc.)</li>
              <li>Music should continue playing uninterrupted</li>
              <li>Try the different controls (play/pause, next, volume, etc.)</li>
              <li>Click the X button to stop the music</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicPlayerDemo;